import { render, staticRenderFns } from "./ProfileToggle.vue?vue&type=template&id=6085f4be&"
import script from "./ProfileToggle.vue?vue&type=script&lang=js&"
export * from "./ProfileToggle.vue?vue&type=script&lang=js&"
import style0 from "./ProfileToggle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAvatar,VImg,VSwitch})
